export const INPUT_PLACEHOLDER = 'Название ЖК, банка, застройщика';
